module.exports = __webpack_public_path__ + "img/xiazai4.508c4489.png";